import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { provideRequestId } from '~ngx-shared/authentication';
import { OpenobserveRumService } from './openobserve-rum.service';

export function provideOpenobserveRum(app: string): (Provider | EnvironmentProviders)[] {
  return [
    provideAppInitializer(() => inject(OpenobserveRumService).start(app)),
    ...provideRequestId(() => {
      const rum = inject(OpenobserveRumService);
      return () => rum.sessionId();
    })
  ];
}
